import { regexStringEscape } from "./regexStringEscape.js";
import { regexStringRemoveCommentsAndWhitespace } from "./regexStringRemoveCommentsAndWhitespace.js";
// builds a regular expression string given a regex string, flags (including the 'x' flag which allows comments and white space), and subroutines (ex. (?&thing) ).  subroutines can be used hierarchically but not recursively.
export function regexStringBuild(regex, flags = "", subroutines = {}) {
    const xFlagPassed = (flags.indexOf('x') >= 0);
    // build the subroutine "find and replace" regexes and replacements used to replace the (?&thing) bits since we'll use them potentially N times in the event some of them use other named subroutines in their own definition
    const subroutineRegexes = [];
    const replacements = [];
    for (const name in subroutines) {
        // add the regex which helps replace subroutine definitions
        subroutineRegexes.push(new RegExp(regexStringEscape("(?&" + name + ")"), "g")); // we only really use regexes (instead of strings) here because using a regex (including the 'g' flag) with the replace function below will replace all instances found on each iteration
        // cache the current subroutine as we alter it if the 'x' flag was passed
        let subroutine = subroutines[name];
        // if the 'x' flag was passed then remove any comments and whitespace from the subroutine
        if (xFlagPassed) {
            subroutine = regexStringRemoveCommentsAndWhitespace(subroutine);
        }
        // add the subroutine's replacement string
        replacements.push("(?:" + subroutine + ")"); // we replace subroutines with their actual definitions; if we received the 'x' flag prepend a linefeed character in case they included a comment which needs to be injected on it's own line... we'll end up removing that spurious white space anyway
    }
    // for each subroutine defined such as (?&thing), find and replace instances in the regex string. do this repeatedly (in a while loop) until there are no more definitions; this outer while loop is necessary because we allow subroutines to use other subroutines hierarchically
    let previousRegex = "";
    const N = replacements.length;
    while (regex !== previousRegex) {
        previousRegex = regex;
        for (let i = 0; i < N; i++) {
            regex = regex.replace(subroutineRegexes[i], replacements[i]);
        }
    }
    // if the 'x' flag was passed then remove any comments and whitespace from the regex
    if (xFlagPassed) {
        regex = regexStringRemoveCommentsAndWhitespace(regex);
    }
    // at this point our regex string should no longer have any known subroutines in it so we can construct and return the javascript RegExp
    return regex;
}
//# sourceMappingURL=regexStringBuild.js.map